var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.61 4.82A2 2 0 0 0 42 5.77L18.45 56.6a1.93 1.93 0 0 0 .94 2.57 1.88 1.88 0 0 0 .57.17 1.93 1.93 0 0 0 2-1.11L45.55 7.4A2 2 0 0 0 44.61 4.82zM20.39 35.76a2 2 0 0 0 .19-1.47 2 2 0 0 0-.91-1.18L7.31 26a1 1 0 0 1-.52-.89 1 1 0 0 1 .51-.89l12.4-7.35a2 2 0 0 0 .88-1.19 1.93 1.93 0 0 0-1.39-2.35 1.66 1.66 0 0 0-.49-.07 1.92 1.92 0 0 0-1 .28L1 23.48a1.93 1.93 0 0 0 0 3.34l16.77 9.65A2 2 0 0 0 20.39 35.76zM63.05 37.48L46.28 27.54a2 2 0 0 0-1-.27 1.94 1.94 0 0 0-1 3.6l12.4 7.35a1 1 0 0 1 0 1.79L44.33 47.12a1.94 1.94 0 0 0-.72 2.64 2 2 0 0 0 2.65.72L63 40.83a1.94 1.94 0 0 0 0-3.35z",
    className: "color010101 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.9c43ac0a688c2fdbf8d6eeddb7831e5c.svg";
export { ForwardRef as ReactComponent };